// extracted by mini-css-extract-plugin
export default {"littleOneNormal":"littleOneNormal_littleOneNormal__vXTAV"};